// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"cbf8806f","422":"fdf21b1b","454":"fdf21b1b"}[chunkId] + ".chunk.css";
};